import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Plus, Trash2 } from 'lucide-react';
import Header from '../../components/Header';
import Title from '../../components/Title';
import Text from '../../components/Text';
import Line from '../../components/Line';
import List from '../../components/List';
import Actions from '../../components/Actions';
import Links from '../../components/Links';
import Tabs from '../../components/Tabs';
import { nameWithDefault } from '../../utils/helpers';
import { CHANNELS_MAX_COUNT } from '../../utils/const';
import Button from '../../components/Button';
import Textarea from '../../components/Textarea';
import TabsCut from '../../components/TabsCut';
import TabsList from '../../components/TabsList';
import TabsListTitle from '../../components/TabsListTitle';
import TabsListItem from '../../components/TabsListItem';
import ConfirmationModal from '../../components/ConfirmationModal';
import SvgIcon from '../../components/SvgIcon';
import MobileMenuHeader from '../../components/MobileMenuHeader';

const fields = ['name', 'description'];
const icons = ['buy', 'text'];
const iconsComponents = icons.map((e) => <SvgIcon name={e} />);

export default function CreateYourChannels(props) {
  const {
    nextClickHandler,
    menuItems,
    selectComponent,
    componentIndex,
    rules,
    backPath,
    locales,
    locales: {
      caseStudies,
      common,
      tipCustomerSegment,
      channel: {
        name,
        createYourChannels: { header, title, text, list, tabs },
      },
    },
  } = props;
  const { collection } = useSelector((state) => state.channel);
  const {
    channel: { addChannel, updateChannel, removeChannel },
  } = useDispatch();
  const [opened, setOpened] = useState(false);

  return (
    <section className="bmc-page" aria-label={header}>
      <Header
        title={header}
        subtitle={name}
        icon="icon-channel"
        locales={locales}
        tipLocales={tipCustomerSegment}
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        componentIndex={componentIndex}
        rules={rules}
        backPath={backPath}
        mobileMenuHeader={
          <MobileMenuHeader icon="ChannelsCanvas" title={name} color="green" />
        }
      />

      <Text>{[text[0]]}</Text>

      <Title text={title[0]} align="left" />

      <List items={list} icons={icons} />

      <Line />

      <h2 className="bmc-page-title">
        <span className="bmc-page-title--green">{title[1]}</span> {title[2]}
      </h2>

      <Text align="center">{[text[1]]}</Text>

      <div className="bmc-page-text bmc-page-text--center margin-top-40">
        <p>
          <span className="bmc-page-text--bold">{text[2]}</span>
          <br />
          {text[3]}
        </p>
      </div>

      <Links />

      <Tabs
        tabs={[common.yourStrategy, common.caseStudy]}
        withBlur
        className="margin-top-40"
      >
        {[
          <div key="strategy">
            {collection.map((channel, index) => (
              <TabsList
                key={channel.id}
                formStyle
                divider={index < CHANNELS_MAX_COUNT - 1}
              >
                <TabsListTitle className="bmc-page-tabs-content-list-title flex flex-row justify-between items-center">
                  {nameWithDefault(channel.name, name, index + 1)}
                  {collection.length > 1 && (
                    <ConfirmationModal
                      className="ml-3 hover:bg-muted-lighter/60 text-muted"
                      body={locales.common.deleteConfirmation}
                      confirmText="Delete"
                      isBlockScroll
                      onConfirm={() => removeChannel({ index, id: channel.id })}
                    >
                      <Trash2 className="w-6 min-w-6 h-auto" />
                    </ConfirmationModal>
                  )}
                </TabsListTitle>

                {fields.map((field, i) => (
                  <TabsListItem
                    divider={false}
                    className={`${i !== fields.length - 1 && 'mb-10'}`}
                    title={tabs[field]}
                    subtitle={tabs[`${field}Sub`]}
                    key={i}
                    icon={iconsComponents[i]}
                    text={
                      // eslint-disable-next-line
                      <Textarea
                        delay={700}
                        placeholder={tabs[field]}
                        value={channel[field]}
                        onChange={(event) =>
                          updateChannel({
                            name: field,
                            value: event.target.value,
                            id: channel.id,
                          })
                        }
                      />
                    }
                  />
                ))}
              </TabsList>
            ))}

            {collection.length < CHANNELS_MAX_COUNT && (
              <div className="bmc-page-tabs-content-actions margin-top-40">
                <Button
                  variant="outline"
                  onClick={addChannel}
                  className="bg-transparent hover:bg-secondary/50 border-secondary/50 text-secondary hover:text-secondary hover:border-secondary w-full"
                >
                  <Plus className="w-7 h-auto" />
                  {tabs.createNewChannel}
                </Button>
              </div>
            )}
          </div>,

          <Tabs
            key="tabs"
            tabs={caseStudies.map((e) => e.name)}
            className="bmc-page-tabs--black bmc-page-tabs--inner"
          >
            {caseStudies.map((item, index) => (
              <div key={index}>
                <TabsCut
                  opened={opened}
                  setOpened={setOpened}
                  caseStudy={item}
                />

                {item.channels.map((channel, i) => (
                  <TabsList
                    key={i}
                    formStyle
                    preview
                    divider={i < item.channels.length - 1}
                  >
                    <TabsListTitle>
                      {tabs.name} {i + 1}
                    </TabsListTitle>

                    {fields.map((field, ii) => (
                      <TabsListItem
                        divider={false}
                        className={`${ii < fields.length - 1 && 'mb-10'}`}
                        key={ii}
                        title={tabs[field]}
                        text={channel[field]}
                        icon={iconsComponents[ii]}
                      />
                    ))}
                  </TabsList>
                ))}
              </div>
            ))}
          </Tabs>,
        ]}
      </Tabs>

      <Actions nextClickHandler={nextClickHandler} buttonName={common.next} />
    </section>
  );
}
